import gql from 'graphql-tag'

export const GET_ROOM_CATEGORIES_PAGINATION_QUERY = gql`
  query GetRoomCategoriesPagination (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $query: String
  ) {
    getRoomCategories (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        query: $query
      }
    ) {
      hasMore
      total
      items {
          id
          title
          order
      }
    }
  }
`
